import Controller, { OnClick } from '@philips-internal/oswald-ui-core/lib/client';
import BaseController from '../../BaseController';
import { ApplicationRoute } from '../../../constants/routes';

@Controller({ component: 'general-layout', fragment: 'logout-inactivity' })
class LogoutInactivityController extends BaseController {

  @OnClick({ target: 'login-return-button' })
  onClickLoginReturnButton(): void {
    this.historyService.push(ApplicationRoute.LOGIN);
  }

}

export default LogoutInactivityController;